import React from 'react'

const PaymentAddPage = () => {
    return (
        <div>PaymentAddPage</div>
    )
}

export default PaymentAddPage